module.exports = __webpack_public_path__ + "img/sameday-active.813df7f6.svg";